import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// TODO: Could probably be it's only little package
import { useCallback, useState } from 'react';
export var useProgress = function useProgress() {
  var _useState = useState({
    loading: true,
    value: undefined
  }),
      _useState2 = _slicedToArray(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1];

  var setLoaded = useCallback(function (value) {
    return setProgress({
      loading: false,
      value: value
    });
  }, [setProgress]);
  var setLoading = useCallback(function () {
    return setProgress({
      loading: true,
      value: undefined
    });
  }, [setProgress]);
  return [progress, setLoaded, setLoading];
};